import React from 'react'
import { authRoles } from '../../auth/authRoles'

const ConfigRoutes = [
    // {
    //     path: '/configurations/sdg',
    //     component: React.lazy(() => import('./SDG_config')),
    //     auth: authRoles.TestPaperCreate,
    // },
    // {
    //     path: '/configurations/add_newsdg',
    //     component: React.lazy(() => import('./AddNewSDGConfig')),

    //     auth: authRoles.TestPaperCreate,
    // },
    {
        path: '/configurations/target',
        component: React.lazy(() => import('./Target_config')),

        auth: authRoles.targetConfiguration,
    },
    {
        path: '/configurations/add_newtarget',
        component: React.lazy(() => import('./AddNewTarget')),

        auth: authRoles.targetConfiguration,
    },
    // {
    //     path: '/configurations/edit_target_type_config',
    //     component: React.lazy(() => import('./EditNewTargetType')),

    //     auth: authRoles.TestPaperCreate,
    // },
    {
        path: '/configurations/add_newtargetdetails',
        component: React.lazy(() => import('./AddNewTargetDetails')),

        auth: authRoles.targetConfiguration,
    },
    {
        path: '/configurations/org_config',
        component: React.lazy(() => import('./Org_config')),

        auth: authRoles.orgConfiguration,
    },
    {
        path: '/configurations/add_neworgconfig',
        component: React.lazy(() => import('./AddNewOrgConfig')),

        auth: authRoles.orgConfiguration,
    },
    {
        path: '/configurations/review_orgtype/:id',
        component: React.lazy(() => import('./Review_OrgConfig')),
        auth: authRoles.orgConfiguration,
    },
    {
        path: '/configurations/expense_config',
        component: React.lazy(() => import('./Expense_config')),

        auth: authRoles.expenseConfiguration,
    },
    {
        path: '/configurations/add_newprojectType',
        component: React.lazy(() => import('./AddNewProjectType')),

        auth: authRoles.expenseConfiguration,
    },
    {
        path: '/configurations/review_projectype/:id',
        component: React.lazy(() => import('./Review_Project_Type')),
        auth: authRoles.expenseConfiguration,
    },
    {
        path: '/configurations/add_newcurrencyType',
        component: React.lazy(() => import('./AddNewCurrencyType')),

        auth: authRoles.expenseConfiguration,
    },
    {
        path: '/configurations/review_currencytype/:id',
        component: React.lazy(() => import('./Review_Currency_Type')),
        auth: authRoles.expenseConfiguration,
    },
    {
        path: '/configurations/add_newexpensecategorytype',
        component: React.lazy(() => import('./AddNewExpenseCategoryType')),

        auth: authRoles.expenseConfiguration,
    },
    {
        path: '/configurations/review_expensecategory/:id',
        component: React.lazy(() => import('./Reveiw_Expense_Category')),
        auth: authRoles.expenseConfiguration,
    },
]

export default ConfigRoutes